import { UserType } from '@/types/user';
import { bffFetch } from './utils';

const userTypeQuery = { query: 'query fetchUserType { userType }' };

export const fetchUserType = async () => {
  return await bffFetch<{ userType: UserType }>(userTypeQuery);
};
